<div
  *transloco="let transloco"
  [ngClass]="{
    'mb-5': !this.props.disableMargin
  }"
  class="formly-repeat mt-3 flex flex-col gap-3">
  @if (this.props.label && !this.props.hideLabel) {
    <label [for]="id" class="mb-5">
      <span class="formly-repeat-title text-2xl">{{ transloco(props.label) }}</span>
      @if (this.props.required && !this.props.hideRequiredMarker) {
        <span aria-hidden="true" class="text-red-600">*</span>
      }
      @if (this.props.description) {
        <p>{{ transloco(this.props.description) }}</p>
      }
      <hr class="m-0" />
    </label>
  }
  @if (this.props.description) {
    <p>{{ transloco(this.props.description) }}</p>
  }

  <div class="flex flex-col">
    <p-table
      [scrollHeight]="
        this.resizedHeight() ? this.resizedHeight() + 'px' : this.props.scrollHeight || '500px'
      "
      [class.table-type-stack]="this.props.stack && !this.layoutService.isDesktopView()"
      [value]="this.field.fieldGroup || []"
      scrollable
      showGridlines
      size="small"
      stripedRows
      tableStyleClass="md:shadow-none shadow">
      <ng-template #header>
        <tr>
          @if (this.props.showIndex) {
            <th></th>
          }
          @for (column of this.props.columns; track column) {
            <th [ngClass]="column.class">
              {{ transloco(column.header || column.key) }}
            </th>
          }
          @if (!this.props.canRemove || this.props.canRemove(this.field, -1)) {
            <th></th>
          }
        </tr>
      </ng-template>

      <ng-template #body let-data let-index="rowIndex">
        <tr>
          @if (this.props.showIndex) {
            <td class="!text-center">{{ index + 1 }}</td>
          }
          @for (column of this.props.columns; track column; let first = $first) {
            <td [class.table-type-first]="first" [class.table-type-line]="!first">
              <div class="flex flex-col items-center">
                @let columnField = this.getField(data, column);
                @if (columnField) {
                  <formly-field class="w-full" [field]="columnField"> </formly-field>
                }
              </div>
            </td>
          }
          @if (
            !this.formControl.disabled &&
            index + 1 > (this.props.minCount || 0) &&
            !(
              this.props.maxCount &&
              this.props.initialCount &&
              this.props.initialCount === this.props.maxCount
            )
          ) {
            <!--TODO: FIX THIS-->
            @if (!this.props.canRemove || this.props.canRemove(this.field, index)) {
              <td class="table-type-remove">
                <div class="align-items-center flex justify-center">
                  <p-button
                    text
                    severity="danger"
                    icon="pi pi-trash"
                    (click)="this.removeField(data)"></p-button>
                </div>
              </td>
            }
          }
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td
            [attr.colspan]="(this.props.columns?.length || 1) + (this.props.showIndex ? 2 : 1)"
            class="text-center">
            {{ transloco(this.props.noDataText || 'no_data') }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    @if (this.props.is_resizable) {
      <div
        (keydown.arrowdown)="this.resizeBy($event, 50)"
        (keydown.arrowup)="this.resizeBy($event, -50)"
        (lostpointercapture)="this.stopResize()"
        (pointerdown)="this.startResize($event)"
        (pointermove)="this.resize($event)"
        [attr.aria-label]="transloco('resize_table')"
        aria-orientation="horizontal"
        class="flex cursor-row-resize touch-none select-none justify-center py-1 text-gray-400 hover:text-gray-600"
        role="separator"
        tabindex="0">
        <i class="pi pi-equals"></i>
      </div>
    }
  </div>

  @if (
    (!this.props.canAdd || this.props.canAdd(this.field)) &&
    !this.formControl.disabled &&
    (this.props.maxCount ? this.props.maxCount > this.formControl.length : true)
  ) {
    <div class="align-items-center my-5 flex justify-end">
      <p-button
        severity="success"
        icon="pi pi-plus"
        [label]="
          this.props.addText
            ? !this.props.addTextValue
              ? transloco(this.props.addText)
              : transloco('add_value', { value: this.props.addTextValue })
            : transloco('add')
        "
        (click)="this.add()"></p-button>
    </div>
  }

  @if (this.showError) {
    <small class="text-red-600">
      <formly-validation-message
        class="ui-message-text"
        [field]="this.field"></formly-validation-message>
    </small>
  }
</div>
